import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { makeObservable, observable } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { cloneDeep } from 'lodash'

import Button from '../../UniformComponents/Button'
import HoverInfo from '../../UniformComponents/HoverInfo'
import PageQuestions from '../PageQuestionsv4'
import PanelAccordion from '../PanelAccordion'
import { trackBuilderPageMenuAction } from '../../utils/MixpanelManager'

import './styles/defaultPage.scss'

@observer
class DefaultPage extends Component {
    @observable show = true

    constructor(props) {
        super(props)
        makeObservable(this)
        this.addPage = this.addPage.bind(this)
        this.removePage = this.removePage.bind(this)
        this.setPageLabel = this.setPageLabel.bind(this)
        this.setRandomise = this.setRandomise.bind(this)
        this.onSortEnd = this.onSortEnd.bind(this)
    }

    componentDidMount() {
        const { store, page, page_id } = this.props

        this.id = page_id

        store.dropTargets[`questionList_${page.id}`] = this
    }

    onSortEnd({ oldIndex, newIndex }) {
        const { store, page } = this.props
        const { survey } = store
        const { questions } = page
        const newArr = []
        console.log(`onSortEnd ${this.id}`)
        console.log(`${survey.mouseDown.id} = ${page.id}`)

        let question

        questions.forEach((q) => {
            newArr.push(q)
        })

        if (survey.mouseDown.id === page.id) {
            if (oldIndex !== newIndex) {
                question = newArr.splice(oldIndex, 1)[0]
                page.moveQuestion({
                    question,
                    new_index: (newIndex + 1),
                    newArr,
                })
            }
        } else if (survey.mouseDown.source === 'qlist') {
            console.log('???? ')
            console.log(survey.questionLibrary.mandatoryQuestions.length)
            console.log(survey.hasMandatoryQuestions)
            question = survey.mouseDown.question
            if (!survey.questionLibrary.mandatoryQuestions
                .some((listQuestion) => listQuestion.questionId !== question.questionId)) {
                survey.questionLibrary.mandatoryQuestionsAdded()
            }
            page.addQuestion(question, null, survey, true, newIndex)
        } else {
            question = survey.mouseDown.questions[oldIndex]
            if (question?.question?.questionTypeCode === 'UV') return
            survey.mouseDown.removeQuestion(question, oldIndex, survey)
            page.addQuestion(question, null, survey, true, newIndex)
        }

        if (survey.questionLibrary.mandatoryQuestions.length === 0
            && survey.hasMandatoryQuestions) {
            survey.quesionLibrary.mandatoryQuestionsAdded()
        }
    }

    getPrevQuestions = () => {
        const { store, page, page_id } = this.props
        const { survey } = store

        page.prev_questions = []

        survey.pages.forEach((surveyPage, index) => {
            if (index < page_id && surveyPage.pageType === 'ST') {
                const pageLabel = `${i18n.t('s_page')}: ${surveyPage.priority} - `
                surveyPage.questions.forEach((question) => {
                    const label = pageLabel + question.questionTitle(store)
                    const type = question.question?.questionTypeCode || 'unknown'
                    if (question.isInheritable()) {
                        page.prev_questions.push({ value: question.id, label, type })
                    }
                })
            }
        })
    }

    setPageLabel({ value }) {
        const { page, store } = this.props
        const { survey } = store

        if (survey.closed || page.title === value) return
        page.title = value
        page.update(store, survey)
    }

    setRandomise(e) {
        const { store, page } = this.props
        const { survey } = store

        if (survey.closed || page.isHidden) {
            return
        }

        page.isRandomized = !page.isRandomized
        e.preventDefault()
        page.update(store, survey)
    }

    openChartModal = () => {
        const { page, store } = this.props

        if (store.survey.closed || page.isHidden) {
            return
        }

        store.showChartCreation = true
        store.chartCreationPageId = page.id
    }

    toggleHide = () => {
        const { store, page } = this.props
        const { survey } = store

        if (survey.closed || page.isLocked) return

        trackBuilderPageMenuAction(store, { action: 'toggle hide page', value: !page.isHidden })

        if (!page.isHidden) {
            store.pageToHide = {
                page,
            }
            store.pageHideConfirm = true
        } else {
            page.isHidden = false
            page.update(store, survey)
        }
    }

    setSkipLogic = () => {
        const { store, page } = this.props

        if (this.isEditingDisabled()) return

        const { survey } = store

        const skipLogic = page.getShowPageLogic(survey.skipLogic) || survey.newShowPage(page)

        trackBuilderPageMenuAction(store, { action: 'open logic menu', logic_type_menu: 'page display/logic' })
        store.skipLogic = store.survey.copySkipLogic(JSON.parse(JSON.stringify(skipLogic)))
        store.previousSkipLogic = cloneDeep(store.survey.skipLogic)
        store.skipLogicConfig = {
            pageIndex: survey.getPageIndex(page.id),
            page,
            type: 'page',
            title: page.title,
            question: null,
        }
        store.skipLogicModalVisible = true
    }

    toggleShow = () => {
        this.show = !this.show
    }

    toggleLocked = () => {
        const { store, page } = this.props
        const { survey } = store
        if ((survey.closed || !store.isMasterSuper()) && !store.isExploriAdmin()) return
        trackBuilderPageMenuAction(store, { action: 'toggle lock page', value: !page.isLocked })
        page.isLocked = !page.isLocked
        page.update(store, survey)
    }

    toggleTemplate = () => {
        const { page, store } = this.props
        if (this.isEditingDisabled()) return
        store.showTemplateCreation = true
        store.templateCreationPageId = page.id
    }

    getPageId = () => {
        const { page } = this.props

        return page.id
    }

    getPagePriority = () => {
        const { page } = this.props

        return page.priority
    }

    getDropQuestion = (index) => {
        const { page } = this.props

        return page.questions[index]
    }

    dropRemove = (index, soft) => {
        const { store, page } = this.props
        console.log(`dropRemove ${page.id}`)
        const { survey } = store
        const question = page.questions[index]

        page.removeQuestion({
            store,
            question,
            index,
            survey,
            soft,
        })

        return question
    }

    dropReorder = (from, to) => {
        const { page, store } = this.props
        console.log(`dropReorder ${page.id}`)

        if (from !== to) {
            // const new_arr = page.questions.slice(0)
            const [question] = page.questions.splice(from, 1)
            page.moveQuestion({
                store,
                question,
                new_index: (to + 1),
            })
        }
    }

    dropMove = (index, question, pageId, soft) => {
        const { store, page } = this.props
        console.log(`dropMove ${page.id} ${pageId}`)

        return page.moveQuestion({
            store,
            question,
            new_index: (index + 1),
            pageId,
            soft,
        })
    }

    dropAdd = (position, question) => {
        const { store, page } = this.props
        console.log(`dropAdd ${page.id}`)
        const { survey } = store

        page.addQuestion({
            question,
            survey,
            position,
            store,
        })
    }

    getDeleteIcon = () => {
        const { store, page } = this.props
        const { survey } = store
        const isOnlyPage = survey.standardPages.length === 1
        const { hasMandatoryQuestions } = page
        const { isAdmin } = store.tokenData

        let icon = null

        if (isOnlyPage) {
            icon = <i className="fal fa-ban deleteicon deletesurveypage" title={i18n.t('s_alt_delpage_prevent')} />
        } else if (!hasMandatoryQuestions) {
            icon = <i className="fal fa-times-circle deleteicon deletesurveypage" onClick={this.removePage} title={i18n.t('s_alt_delpage')} />
        } else if (isAdmin) {
            icon = <i className="fal fa-minus-square deleteicon deletesurveypage" onClick={this.removePage} title={i18n.t('s_alt_delpage_mandatory_prevent')} />
        } else {
            icon = <i className="fal fa-ban deleteicon deletesurveypage" title={i18n.t('s_alt_delpage_mandatory_prevent')} />
        }
        return icon
    }

    getRouting = () => {
        const { page, store } = this.props
        const { survey } = store
        let label = i18n.t('form.general.please_select_ellipsis')
        let value = 0
        const skipToPage = store.survey.skipLogic.find((sl) => (sl.action.kind === 'PageToPage' && sl.trigger.condition.pageId === page.id))
        if (skipToPage) {
            const targetPage = survey.pages.find((page) => page.id === skipToPage.action.pageId)
            if (targetPage && targetPage.priority > page.priority) {
                label = `${i18n.t('s_page')}: ${targetPage.priority} ${(targetPage.title ? (` - ${targetPage.title}`) : '')}`
                value = targetPage.id
            } else {
                label = 'Invalid SkipLogic -- remove'
                value = '-1'
            }
        }

        return {
            value,
            label,
        }
    }

    getRoutingPages = (currIndex) => {
        const { store } = this.props
        const { survey } = store

        let index = 0
        const pages = [
            {
                label: i18n.t('form.general.please_select_ellipsis'),
                value: 0,
            }, ...survey.pages.reduce((arr, surveyPage) => {
                if (currIndex < index) {
                    arr.push({ value: surveyPage.id, label: `${i18n.t('s_page')}: ${surveyPage.priority} ${(surveyPage.title ? (` - ${surveyPage.title}`) : '')}` })
                }
                index += 1
                return arr
            }, []),
        ]

        return pages
    }

    dataViewerLink = () => {
        const { page } = this.props

        return (
            <a className="redlink" target='_blank' href={'/intranet/dataviewer?schema=explori_v3&tablename=survey_page_question&f1=surveyPageId&op1=eq&val1='+ page.id + '&viewdata=true'}>
                {page.id}
            </a>
        )
    }

    previewPage = () => {
        const { page, store } = this.props

        if (page.isHidden) {
            return
        }
        trackBuilderPageMenuAction(store, { action: 'preview page' })
        let link = store.survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)
        link += `&pageId=${page.id}`
        store.gotoExternal(link)
    }

    onSortItemsEnd = () => {
        console.log('onSortItemsEnd')
    }

    isEditingDisabled = () => {
        const { store, page } = this.props
        const { survey } = store

        return survey.closed || page.isHidden || page.isLocked
    }

    setPageRouting = (obj) => {
        const { page, store } = this.props
        console.log('PageToPage')
        const skipToPage = store.survey.skipLogic.find((sl) => (sl.action.kind === 'PageToPage' && sl.trigger.condition.pageId === page.id))

        if (obj.value === 0 && skipToPage) {
            skipToPage.remove(store)
        } else if (obj && skipToPage) {
            skipToPage.action.pageId = obj.value
            skipToPage.save(store)
        } else if (obj && !skipToPage) {
            const skipLogic = store.survey.newPageToPage(page.id, obj.value)
            skipLogic.save(store)
        }
    }

    createQuestion = () => {
        const { store, page, page_id } = this.props
        const { survey } = store

        if (this.isEditingDisabled() || this.rapidSurveyLimitReached()) return

        store.questionDetails = {
            action: 'newQuestion',
            prevQuestions: page.prev_questions,
            survey: store.survey,
            pageIndex: page_id,
            tokenData: store.tokenData,
            categoryId: survey.questionCategory.categoryId,
            oid: store.isTemplate ? 3 : 6,
        }

        store.showQuestionEditor = true
    }

    addPage() {
        const { store, page } = this.props
        const { survey } = store

        if (this.isEditingDisabled()) return

        const currentPageBlockIndex = survey.pageBlocks
            .findIndex((pb) => pb.pages.includes(page.id))

        if (currentPageBlockIndex > -1) {
            survey.addPage(store, (page.priority + 1), survey.pageBlocks[currentPageBlockIndex].id)
            return
        }

        survey.addPage(store, (page.priority + 1))
    }

    removePage(e) {
        const { page, store } = this.props

        if (this.isEditingDisabled()) return

        store.pageToDeleteId = page.id
        store.pageToDeleteType = 'ST'
        store.pageDeleteConfirm = true
        e.preventDefault()
    }

    pageHasPageLogic = () => {
        const { store, page } = this.props
        const { survey } = store
        const { skipLogic } = survey
        const pageId = R.pathOr('', ['id'], page)

        const hasLogic = skipLogic.find((sl) => (
            (sl.action.kind === 'ShowPage') && R.pathOr(null, ['action', 'pageId'], sl) === pageId
        ))

        return hasLogic
    }

    pageHasQuestionLogic = () => {
        const { store, page } = this.props
        const { survey } = store
        const { skipLogic } = survey
        const pageId = R.pathOr('', ['id'], page)
        const getPageQuestionId = R.pathOr(null, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'pageQuestionId'])

        const hasLogic = page.questions.find((pq) => skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && getPageQuestionId(sl) === R.pathOr('', ['id'], pq)))
        const hasPageToPageLogic = skipLogic.find((sl) => (
            (sl.action.kind === 'PageToPage') && R.pathOr(null, ['trigger', 'condition', 'pageId'], sl) === pageId
        ))

        return hasLogic || hasPageToPageLogic
    }

    renderAddQuestionButton = (page, canAdd, survey) => (
        <Button
            onClick={this.createQuestion}
            disabled={page.isLocked || page.isHidden || !canAdd || survey.closed}
            cssClass="regular secondary"
            label={i18n.t('s_add_question')}
            icon="fal fa-circle-plus"
        />
    )

    rapidSurveyLimitReached = () => {
        const { store } = this.props
        const { survey } = store
        const isRapidSurvey = R.pathOr(false, ['metadata', 'isRapidSurvey'], survey)
        return isRapidSurvey && survey.rapidSurveyRemainingQuestions < 1
    }

    render() {
        const {
            page_id, page, store, history, draggableId, pageDragId,
        } = this.props
        const { survey, userData } = store
        const { questions } = page
        const label = page.title
        this.getPrevQuestions()

        const canRemove = survey.standardPages.length > 1
            && (!page.hasMandatoryQuestions || store.tokenData.isAdmin)
        const canEdit = userData.role <= 140
        const isEditingDisabled = this.isEditingDisabled()
        const canAddQuestions = !this.rapidSurveyLimitReached()
        // TODO: move the above checks into helper functions on the respective models

        return (
            <PanelAccordion
                title={`Page ${page.priority}`}
                subtitle={label}
                show={pageDragId === draggableId ? false : this.show}
                toggle={this.toggleShow}
                hidden={page.isHidden}
                disable={this.toggleHide}
                preview={this.previewPage}
                showRouting={page.priority > 1}
                routing={() => this.setSkipLogic()}
                lock={this.toggleLocked}
                template={this.toggleTemplate}
                options="page"
                pageId={page_id}
                page={page}
                canEdit={!isEditingDisabled && canEdit}
                setPageLabel={this.setPageLabel}
                remove={canRemove ? this.removePage : null}
                disabled={survey.closed && !store.isExploriAdmin()}
                showDragHandle={!isEditingDisabled}
                pageHasPageLogic={this.pageHasPageLogic()}
                pageHasQuestionLogic={this.pageHasQuestionLogic()}
                openChartModal={this.openChartModal}
                store={store}
            >
                <div className="page-accordion-content">
                    <div style={{ marginBottom: 3 }}>
                        {store.showIds
                            && <span style={{ marginLeft: 5 }}>{this.dataViewerLink()}</span>}
                    </div>

                    <Droppable droppableId={`questionList_${page.id}`}>
                        {(provided, snapshot) => (
                            <ul
                                key={`sortable-container${page.id}`}
                                className="nopadding"
                                style={{ border: '0px solid red', minHeight: 29 }}
                                ref={provided.innerRef}
                            >
                                {
                                    questions.map((question, index) => (
                                        <Draggable
                                            key={`${question.questionId}_${index}`}
                                            draggableId={`${question.questionId}_${index}`}
                                            isDragDisabled={survey.closed || page.isLocked}
                                            id={`${question.questionId}_${index}`}
                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <PageQuestions
                                                    provided={provided}
                                                    key={question.questionId}
                                                    question={question}
                                                    pageIndex={page_id}
                                                    store={store}
                                                    question_id={index}
                                                    page={page}
                                                    history={history}
                                                    isDragging={snapshot.isDragging}
                                                />
                                            )}
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </ul>
                        )}
                    </Droppable>

                    <div className="m">
                        <div className="page-accordion-content-actions">
                            <Button
                                cssClass="regular primary"
                                onClick={this.addPage}
                                disabled={page.isLocked || page.isHidden || survey.closed}
                                label={i18n.t('s_add_surveypage')}
                                icon="fal fa-circle-plus"
                            />
                            <div>
                                {!canAddQuestions ? (
                                    <HoverInfo
                                        cssClass="hover-info w-300"
                                        desc={i18n.t('surveyBuilder.rapidSurvey.button.disabledTooltip')}
                                        dir="left"
                                    >
                                        {this.renderAddQuestionButton(page, canAddQuestions, survey)}
                                    </HoverInfo>
                                ) : (
                                    this.renderAddQuestionButton(page, canAddQuestions, survey)
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </PanelAccordion>
        )
    }
}

export default DefaultPage
